<template>
  <div v-if="serverIsBusy" class="project-spinner spinner-holder" :class="{'local-spinner':localSpinner}">
    <spinner
            :animation-duration="1000"
            :size="100"
            :color="'#068CFF'"
    ></spinner>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners';

export default {
  name: 'ServerProcessing',
  components: {
    spinner: SwappingSquaresSpinner,
  },
  props: {
    serverIsBusy: {
      required: true,
      type: Boolean,
    },
    localSpinner: {
      type: Boolean
    }
  },
  methods: {
    closeModal(ref) {
      this.$refs[ref].hide();
    },
  },
};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';

.spinner-holder {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  padding-top: 10%;
  height: 100%;
  width: 100%;
  @include sm {
    position: static;
  }
  &:before {
    content: '';
    display: block;
    z-index: 1;
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }
}
.local-spinner {
  &:before {
    position: absolute;
  }
}
</style>
